/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { usuariosControllerConfirmarResetPassword } from '../fn/usuarios/usuarios-controller-confirmar-reset-password';
import { UsuariosControllerConfirmarResetPassword$Params } from '../fn/usuarios/usuarios-controller-confirmar-reset-password';
import { usuariosControllerEnviarResetPassword } from '../fn/usuarios/usuarios-controller-enviar-reset-password';
import { UsuariosControllerEnviarResetPassword$Params } from '../fn/usuarios/usuarios-controller-enviar-reset-password';

@Injectable({ providedIn: 'root' })
export class UsuariosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usuariosControllerEnviarResetPassword()` */
  static readonly UsuariosControllerEnviarResetPasswordPath = '/api/usuarios/enviar-reset-password/{email}';

  /**
   * Envío de email de reseteo de contraseña para usuario o médico.
   *
   * Envío de email de reseteo de contraseña para usuario o médico
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuariosControllerEnviarResetPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuariosControllerEnviarResetPassword$Response(params: UsuariosControllerEnviarResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return usuariosControllerEnviarResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Envío de email de reseteo de contraseña para usuario o médico.
   *
   * Envío de email de reseteo de contraseña para usuario o médico
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuariosControllerEnviarResetPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuariosControllerEnviarResetPassword(params: UsuariosControllerEnviarResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.usuariosControllerEnviarResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usuariosControllerConfirmarResetPassword()` */
  static readonly UsuariosControllerConfirmarResetPasswordPath = '/api/usuarios/confirmar-reset-password/{uuidResetPassword}';

  /**
   * Recibe el uuid del reseteo de clave.
   *
   * Aplica la contraseña y elimina el registro
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuariosControllerConfirmarResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuariosControllerConfirmarResetPassword$Response(params: UsuariosControllerConfirmarResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return usuariosControllerConfirmarResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Recibe el uuid del reseteo de clave.
   *
   * Aplica la contraseña y elimina el registro
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuariosControllerConfirmarResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuariosControllerConfirmarResetPassword(params: UsuariosControllerConfirmarResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.usuariosControllerConfirmarResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
